/* ============================================================
   ToTheLove — Best-Sellers (assets/tothelove-best-sellers.js)
   Fleches de navigation pour la piste horizontale mobile.
   - Custom element <ttl-best-sellers> (reinit auto au shopify:section:load).
   - Pilote le scroller natif scroll-snap : un clic = une carte.
   - Desactive prev/next aux extremites.
   - Masque les fleches s'il n'y a rien a faire defiler (pas de debordement) ;
     le CSS les masque aussi des le passage en grille desktop (>=990px).
   - Scoping strict [data-ttl-bs-*], aucun selecteur global.
   ============================================================ */
(function () {
  if (customElements.get('ttl-best-sellers')) return;

  class TtlBestSellers extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-ttl-bs-scroller]');
      this.nav = this.querySelector('[data-ttl-bs-nav]');
      this.prevBtn = this.querySelector('[data-ttl-bs-prev]');
      this.nextBtn = this.querySelector('[data-ttl-bs-next]');
      if (!this.scroller || !this.nav) return;

      this._update = this._update.bind(this);
      this._onScroll = this._onScroll.bind(this);

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this._scrollByCard(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this._scrollByCard(1));
      this.scroller.addEventListener('scroll', this._onScroll, { passive: true });

      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(this._update);
        this._ro.observe(this.scroller);
      } else {
        window.addEventListener('resize', this._update);
      }

      // Les titres en Jost (swap) changent la largeur des cartes apres coup.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this._update);
      }

      this._update();
    }

    disconnectedCallback() {
      if (this._ro) this._ro.disconnect();
      window.removeEventListener('resize', this._update);
    }

    _stepWidth() {
      const item = this.scroller.querySelector('.ttl-bestsellers__item');
      if (!item) return this.scroller.clientWidth * 0.8;
      const styles = getComputedStyle(this.scroller);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    _scrollByCard(dir) {
      this.scroller.scrollBy({ left: dir * this._stepWidth(), behavior: 'smooth' });
    }

    _onScroll() {
      if (this._raf) return;
      this._raf = requestAnimationFrame(() => {
        this._raf = null;
        this._updateArrows();
      });
    }

    _update() {
      const overflow = this.scroller.scrollWidth - this.scroller.clientWidth > 2;
      this.nav.classList.toggle('is-active', overflow);
      this._updateArrows();
    }

    _updateArrows() {
      const max = this.scroller.scrollWidth - this.scroller.clientWidth;
      const x = this.scroller.scrollLeft;
      if (this.prevBtn) this.prevBtn.disabled = x <= 2;
      if (this.nextBtn) this.nextBtn.disabled = x >= max - 2;
    }
  }

  customElements.define('ttl-best-sellers', TtlBestSellers);
})();
